"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CardLoader = function CardLoader(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactContentLoader["default"], _extends({
    width: "100%",
    height: "40"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "52",
    y: "23",
    rx: "0",
    ry: "0",
    width: "125",
    height: "13"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "52",
    y: "5",
    rx: "0",
    ry: "0",
    width: "171",
    height: "13"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "20",
    cy: "20",
    r: "15"
  }));
};

CardLoader.propTypes = {
  backgroundColor: _propTypes["default"].string,
  foregroundColor: _propTypes["default"].string
};
CardLoader.defaultProps = {
  backgroundColor: "#f3f3f3",
  foregroundColor: "#d9d9d9"
};
var _default = CardLoader;
exports["default"] = _default;